import { type AxiosInstance } from "axios";
import type { PropertyCodePictureRequestListResponse } from "@/features/propertyCodeAcquisition/types";

// 取得履歴一覧の API 呼び出し層。
// hook（usePropertyCodePictureRequestList）は SWR の設定・状態管理に専念し、HTTP 呼び出しは本 fetcher に集約する。

/** 取得履歴一覧エンドポイントを生成する。GET /api/property-codes/{code}/picture-requests。 */
export const buildPropertyCodePictureRequestEndpoint = (
  propertyCode: string
): string => `/property-codes/${propertyCode}/picture-requests`;

/**
 * 取得履歴一覧を取得する fetcher。
 * BE は履歴を全件返却する（API ページネーションなし）。FE はクエリを付けず全件受領し、
 * テーブルの表示ページングはクライアント側（PropertyCodePictureRequestTable）で行う。
 * 地番は送信・記録しない。
 * @param apiClient JWT 認証付き apiClient
 * @param propertyCode 物件コード（UUID）
 */
export const getPropertyCodePictureRequestList = async (
  apiClient: AxiosInstance,
  propertyCode: string
): Promise<PropertyCodePictureRequestListResponse> => {
  const { data } = await apiClient.get<PropertyCodePictureRequestListResponse>(
    buildPropertyCodePictureRequestEndpoint(propertyCode)
  );

  return data;
};
